import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom"; // ✅ Import navigation hook
import "../styles/ServicePlans.css";

const OtherServicePlans = ({ servicePlans }) => {
  const navigate = useNavigate(); // ✅ Initialize navigation
  const [viewedServices, setViewedServices] = useState([]);

  // ✅ Load viewed services from localStorage
  useEffect(() => {
    const storedViewedServices = localStorage.getItem("viewedOtherServices");
    if (storedViewedServices) {
      setViewedServices(JSON.parse(storedViewedServices));
    }
  }, []);

  // ✅ Handle when a user clicks on a service card
  const handleServiceClick = (serviceId,serviceName) => {
    if (!viewedServices.includes(serviceId)) {
      const updatedViewedServices = [...viewedServices, serviceId];
      setViewedServices(updatedViewedServices);
      localStorage.setItem("viewedOtherServices", JSON.stringify(updatedViewedServices)); // ✅ Use localStorage
    }

    // ✅ Navigate to details page
   // navigate(`/so`, { state: { serviceId } });
   //navigate(`/services`, { state: { serviceId} });
   navigate(`/services`, {
    state: { serviceId, serviceName }
  });
  
  };

  return (
    <div className="rounded mb-4">
      {servicePlans.map((plan) => (
        <div
        
          key={plan.serviceId}
          className="service-card mb-4 border border-primary rounded p-3"
          style={{ backgroundColor: "#fff", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)" }}
          onClick={() => handleServiceClick(plan.serviceId,plan.serviceName)} // ✅ Add navigation on click
        >
          {/* ✅ Show "New" label only for services not clicked before */}
          {/*
  {!viewedServices.includes(plan.serviceId) && (
    <span className="new-badge">New</span>
  )}
*/}
 {/* ✅ Show "New" label only for services from backend api call */}
{plan.new === 'true' ? (
  <span className="new-badge">New</span>
) : (
 <span></span>
)}

 



          <h2 className="h5">{plan.serviceName}</h2>

          <p className="text-secondary">{plan.serviceDescription}</p>

          <div style={{ borderBottom: "1px solid #ddd", marginBottom: "1rem" }}></div>

          <div style={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
            <span className="text-primary" style={{ textDecoration: "none", color: "#004fbd" }}>
              View Details
            </span>
            <div
              className="ms-2 p-2 rounded-circle"
              style={{
                border: "2px solid #5DC486",
                color: "#5DC486",
                width: "20px",
                height: "20px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <i className="fas fa-chevron-right"></i>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default OtherServicePlans;
